// extracted by mini-css-extract-plugin
export default {"spinner_container":"Loader_spinner_container__bzUmH","spinner":"Loader_spinner__a2c0E","spinner-d3wgkg":"Loader_spinner-d3wgkg__RE+AP"};